var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChevronRightSmall = function SvgChevronRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.264 6.264a.9.9 0 000 1.272L13.727 12l-4.463 4.464a.9.9 0 001.272 1.272l5.1-5.1a.9.9 0 000-1.272l-5.1-5.1a.9.9 0 00-1.272 0z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjI2MzUgNi4yNjM2MUM4LjkxMjAzIDYuNjE1MDggOC45MTIwMyA3LjE4NDkzIDkuMjYzNTEgNy41MzY0TDEzLjcyNzEgMTJMOS4yNjM1IDE2LjQ2MzZDOC45MTIwMyAxNi44MTUxIDguOTEyMDMgMTcuMzg0OSA5LjI2MzUxIDE3LjczNjRDOS42MTQ5OCAxOC4wODc5IDEwLjE4NDggMTguMDg3OSAxMC41MzYzIDE3LjczNjRMMTUuNjM2MyAxMi42MzY0QzE1Ljk4NzggMTIuMjg0OSAxNS45ODc4IDExLjcxNSAxNS42MzYzIDExLjM2MzZMMTAuNTM2MyA2LjI2MzZDMTAuMTg0OCA1LjkxMjEzIDkuNjE0OTggNS45MTIxMyA5LjI2MzUgNi4yNjM2MVoiIGZpbGw9IiMwMjNGODAiLz4KPC9zdmc+Cg==";
export { SvgChevronRightSmall as ReactComponent };